const translations = {
    cancel: 'Cancel',
    continueButton: 'Continue',
    detailsTab: 'Details',
    discardConfirmCancel: 'Keep editing',
    discardConfirmConfirm: 'Discard',
    discardConfirmMessage: 'Discard the staged files and close this drawer?',
    discardConfirmTitle: 'Discard changes?',
    drawerTitle: 'New Flight Group',
    drawerTitleFromSelection: 'New Flight Group from Selection',
    filesTab: 'Files',
    reviewTab: 'Review',
    save: 'Save',
    saveError: 'Failed to create flight group',
    saveErrorConflict: 'One or more files were already uploaded. Remove duplicates and try again.',
    saveErrorUpload: 'A file failed to upload. Check your connection and try again.',
    saving: 'Saving',
    stageAttachingReports: 'Attaching reports',
    stageAttachingWorkOrder: 'Attaching work order',
    stageCreatingGroup: 'Creating flight group',
    stageUploadingFiles: 'Uploading files'
};

export default translations;
